import { Inheritance } from 'src/domain';
import { useProductLineSplitInheritanceQuery } from './useProductLineSplitInheritanceQuery';

export const useProductLineSplitQuery = (inheritance?: Inheritance) => {
    const { data, expected, productLineGroups, error, loading } = useProductLineSplitInheritanceQuery(inheritance);
    return { expectedSplit: expected, data, productLines: productLineGroups, error, loading };
};
